import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['syncStatus', 'integrationCard'];

  connect() {
    this.syncStatus();
  }

  syncStatus() {
    let company = $(this.integrationCardTarget).data('companyId');
    let integration = $(this.integrationCardTarget).data('integrationId');

    setInterval(() => {
      Rails.ajax({
        url: `/companies/${company}/integrations/${integration}/sync_status`,
        type: 'GET',
        dataType: 'script',
        success: (data) => {
          if (data.status !== 'in_progress') {
            $(this.syncStatusTarget).addClass('d-none');
          } else {
            $(this.syncStatusTarget).removeClass('d-none');
          }
        }
      });
    }, 5000);
  }
}
